import React, { useCallback, useState } from 'react';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material//AddCircleOutlineOutlined';
import ExpandMoreIcon from '@mui/icons-material//ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  LinearProgress,
  List,
  ListItem,
  Typography,
} from '@mui/material';
import { FileModel } from 'api';
import TaskStatusLabel from 'pages/ProcessManagement/components/TaskStatusLabel/TaskStatusLabel';
import { styles } from './styles';
import { FileAccordionProps } from './types';

const FileAccordion = ({ requestedFile, handleUploadFiles, loadingFiles, progress }: FileAccordionProps) => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = useCallback(() => {
    setExpanded(prevExpanded => !prevExpanded);
  }, []);

  const isLoading = requestedFile.id ? loadingFiles[requestedFile.id] : false;

  return (
    <Accordion key={requestedFile.id} style={styles.accordion} expanded={expanded} onChange={handleChange}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <svg style={styles.svgIcon} viewBox="0 0 32 38" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M20.8 11.0833H29.6L20.8 2.375V11.0833ZM9.6 0H22.4L32 9.5V28.5C32 29.3399 31.6629 30.1453 31.0627 30.7392C30.4626 31.333 29.6487 31.6667 28.8 31.6667H9.6C8.75131 31.6667 7.93737 31.333 7.33726 30.7392C6.73714 30.1453 6.4 29.3399 6.4 28.5V3.16667C6.4 2.32681 6.73714 1.52136 7.33726 0.927495C7.93737 0.33363 8.75131 0 9.6 0ZM3.2 6.33333V34.8333H28.8V38H3.2C2.35131 38 1.53737 37.6664 0.937258 37.0725C0.337142 36.4786 0 35.6732 0 34.8333V6.33333H3.2Z"
            fill="#043A6E"
          />
        </svg>
        <Box flexGrow={1} marginLeft="3rem">
          <Typography style={styles.fileName}>{requestedFile.name}</Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box display="flex" flexDirection="column" width="100%">
          <Box display="flex" justifyContent="space-between">
            <Box marginLeft="5rem">
              <List style={styles.fileList}>
                {requestedFile.files.map((file: FileModel) => (
                  <ListItem key={file.id} style={styles.fileItem}>
                    <Typography style={styles.fileLink}>
                      {file.filename && file.file_type ? `${file.filename}.${file.file_type}` : null}
                    </Typography>
                  </ListItem>
                ))}
              </List>
              <label htmlFor={`file-input-${requestedFile.id}`}>
                <Button
                  variant="text"
                  color="primary"
                  startIcon={<AddCircleOutlineOutlinedIcon />}
                  style={{
                    ...styles.uploadButton,
                    textTransform: 'none',
                  }}
                  component="span">
                  Add more files
                </Button>
                <input
                  id={`file-input-${requestedFile.id}`}
                  type="file"
                  style={styles.hiddenInput}
                  onChange={event => handleUploadFiles(event, requestedFile.id)}
                  multiple
                />
              </label>
              {isLoading && (
                <Box style={styles.progressBar}>
                  <LinearProgress variant="determinate" value={progress ?? 0} />
                </Box>
              )}
            </Box>
            <TaskStatusLabel label={isLoading ? 'UPLOADING' : 'COMPLETED'} status="completed" />
          </Box>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default FileAccordion;
